import React, { useRef, useState } from "react";
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import { storage } from "../../../firebase";
import './ImageUploader.css';

const slugify = (name) => name.toLowerCase().replace(/[^a-z0-9.]+/g, '-').replace(/-+/g, '-');

const ImageUploader = ({ folder, accept, label, value, onUploaded, onRemove }) => {
    const inputRef = useRef(null);
    const [progress, setProgress] = useState(null);
    const [error, setError] = useState(null);

    const handleFile = (file) => {
        if (!file) return;
        setError(null);
        setProgress(0);
        const path = `${folder}/${Date.now()}-${slugify(file.name)}`;
        const storageRef = ref(storage, path);
        const task = uploadBytesResumable(storageRef, file);

        task.on(
            'state_changed',
            (snapshot) => {
                setProgress(Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100));
            },
            (err) => {
                setError('Upload fehlgeschlagen: ' + err.message);
                setProgress(null);
            },
            async () => {
                const url = await getDownloadURL(task.snapshot.ref);
                onUploaded({ url, path, name: file.name });
                setProgress(null);
            }
        );
    };

    const handleRemove = async () => {
        if (value?.path) {
            try {
                await deleteObject(ref(storage, value.path));
            } catch (err) {
                // file may already be gone; ignore
            }
        }
        onRemove();
    };

    return (
        <div className="image-uploader">
            <span className="image-uploader-label">{label}</span>
            {value ? (
                <div className="image-uploader-preview">
                    {value.url && (accept === 'video/*'
                        ? <video src={value.url} controls className="image-uploader-media" />
                        : <img src={value.url} alt={value.name || ''} className="image-uploader-media" />
                    )}
                    <button type="button" className="image-uploader-remove" onClick={handleRemove}>
                        Entfernen
                    </button>
                </div>
            ) : (
                <div className="image-uploader-dropzone" onClick={() => inputRef.current?.click()}>
                    {progress !== null
                        ? <span>Hochladen… {progress}%</span>
                        : <span>Datei auswählen</span>
                    }
                    <input
                        ref={inputRef}
                        type="file"
                        accept={accept}
                        hidden
                        onChange={(e) => handleFile(e.target.files?.[0])}
                    />
                </div>
            )}
            {error && <p className="image-uploader-error">{error}</p>}
        </div>
    );
};

export default ImageUploader;
